import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { images } from '../../../shared/assets/images';

const variants = {
  visible: { opacity: 1, scale: 1, transition: { duration: 0.8 } },
  hidden: { opacity: 0, scale: 0.5 },
};

const contactCards = [
  { title: 'Dirección', detail: 'C. Anatolio de Fuentes García, 2\nSanta Cruz de Tenerife', icon: faMapMarkerAlt },
  { title: 'Teléfono', detail: '615034942', icon: faPhone },
  { title: 'Email', detail: 'Mundolandiapark2@gmail.com', icon: faEnvelope },
];

function ContactCard({ title, detail, icon }) {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: false });

  useEffect(() => {
    controls.start(inView ? 'visible' : 'hidden');
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={variants}
      className="flex flex-col items-center text-center min-w-[250px] max-w-xs p-6 bg-white rounded-xl shadow-xl hover:shadow-2xl transition duration-500"
    >
      <div className="text-4xl text-orange-400 mb-4">
        <FontAwesomeIcon icon={icon} />
      </div>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">{title}</h2>
      <p className="text-gray-600 whitespace-pre-line">{detail}</p>
    </motion.div>
  );
}

export default function ContactSection() {
  return (
    <section id="contacto" className="py-20 bg-gradient-to-r from-orange-50 to-pink-50">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-blue-900 mb-12">Contacto y horarios</h1>

        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className="lg:w-1/2 flex justify-center">
            <img src={images.homeBackground} alt="Contacto Mundolandia" className="rounded-2xl shadow-xl w-full max-w-lg" />
          </div>

          <div className="lg:w-1/2 flex flex-wrap justify-center gap-6">
            {contactCards.map((info) => (
              <ContactCard key={info.title} title={info.title} detail={info.detail} icon={info.icon} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
